export enum GridConnectionLevel {
  'BT' = 'BT',
  'HTA' = 'HTA',
  'HTB1' = 'HTB1',
  'HTB2' = 'HTB2',
}
